import { IApiError } from '@/models/apiError.model';
import { IStore } from '@/models/stores.model';

export const STORES_SLICE_NAME = 'stores';

export interface StoresState {
  storeList: IStore[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: StoresState = {
  storeList: null,
  isLoading: false,
  error: null,
};
